import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema } from '../../shared/types'
import {
  ListOrderChargesResponseSchema,
  OrderChargeSchema,
  RecordOrderChargeBodySchema,
} from './schemas'

const c = initContract()

const options = {
  pathPrefix: '/api/v1',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    409: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

/**
 * Order-side records of additional charges (`order_charge`). Orchestration
 * records one row per extra payment taken against an already-paid order; a
 * subscriber will turn that row into the NetSuite outbox row locally. Kept as
 * its own router, matching `orderRefundsContract`.
 */
export const orderChargesContract = c.router(
  {
    recordOrderCharge: {
      method: 'POST',
      description: 'Record an additional charge against an already-paid order: one row per extra payment. The row stores paymentId only — the money stays in payment.payments and is fetched by that id, so the two can never drift. Idempotent per payment: re-recording the same paymentId for the same order returns the existing row as 200 (created rows return 201). An order can hold several charges. Returns 404 if the order does not exist, 409 if the paymentId is already recorded against a different order.',
      path: '/orders/:orderId/charges',
      pathParams: z.object({ orderId: z.string().uuid() }),
      body: RecordOrderChargeBodySchema,
      responses: {
        200: OrderChargeSchema,
        201: OrderChargeSchema,
        404: ErrorResponseSchema,
        409: ErrorResponseSchema,
      },
    },

    listOrderCharges: {
      method: 'GET',
      description: 'Return every additional-charge record for an order in insertion order. Returns an empty list for an order that was never upcharged.',
      path: '/orders/:orderId/charges',
      pathParams: z.object({ orderId: z.string().uuid() }),
      responses: {
        200: ListOrderChargesResponseSchema,
      },
    },
  },
  options,
)
